import React, { useEffect, useState } from "react";
import classes from "./ScormContent.module.scss";
import IframeLoader from "../ViewContentLoading/IframeLoader";

const ScormContent = ({ shotclassData }) => {
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(true);

  useEffect(() => {
    setIsIFrameLoaded(true); // Show loader initially
  }, [shotclassData?.VideoUrl]);

  const handleIframeLoad = () => {
    setIsIFrameLoaded(false); // Hide loader when iframe content is fully loaded
  };
  return (
    <div className={classes.scormContent}>
      {isIFrameLoaded && <IframeLoader isIFrameLoaded={isIFrameLoaded} />}

      <iframe
        id="iframeInScorm"
        className={`${classes.scormContent__iframeplayer} ${
          isIFrameLoaded ? classes.hiddenIframe : ""
        }`}
        allowFullScreen
        src={shotclassData?.VideoUrl}
        title={shotclassData?.Name}
        style={{
          width: "96%",
          height: "85%",
          position: "absolute",
        }}
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default ScormContent;
